export function isHighlightingCardEmpty(props) {
    return !props?.button || !props?.title;
}
